import CityServicePage from "@/pages/city-service/CityServicePage";
import { torontoGasLine } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={torontoGasLine} />; }
